

















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Room from "../../../store/entities/room";
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
@Component
export default class CreateRoom extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  room: Room = new Room();
  spinShow = false;
  id: string ='';
  isUpdate()
  {
    return !Util.isNull(this.id) && !Util.isEmpty(this.id);
  }
  save() {
    (this.$refs.roomForm as any).validate(async (valid: boolean) => {
          if (valid) {
            var confirmMsg = this.isUpdate()? this.L('Confirm.UpdateRoom'):this.L('Confirm.CreateRoom');
              this.$Modal.confirm({
                title:this.L('Tips'),
                content:confirmMsg,
                okText:this.L('Yes'),
                cancelText:this.L('No'),
                onOk:async()=>{
                    this.spinShow=true;
                    try {
                         var successMsg = '';
                         if(this.isUpdate())
                         {
                            successMsg = 'Success.UpdateRoom';
                             await this.$store.dispatch({
                                type: "room/update",
                                data: this.room
                              });
                         }
                         else
                         {
                            successMsg = 'Success.CreateRoom';
                             await this.$store.dispatch({
                              type: "room/create",
                              data: this.room
                            });
                         }
                        Util.showSuccessMsg(this,successMsg);
                        this.$emit("save-success");
                        this.onGoBack();
                        this.spinShow=false;
                    } catch (error) {
                       this.spinShow=false; 
                    }
                }
        });
      }
    });
    
  }
   onGoBack(){
      (this.$refs.roomForm as any).resetFields();
      this.$emit("input", false);
      this.$root.$router.push({name: 'room'});
  }
   async getRoomInfo()
  {
       this.id =  this.$root.$router.currentRoute.params.id;
      if(Util.isNull(this.id) || Util.isEmpty(this.id))
        return;
      await this.$store.dispatch({
          type:'room/get',
          data: { id : this.id}
      }).then((result) => {
          this.room = result;
      });
  }
  roomRule = {
    id: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur"
      }
    ]
  };
 
  async created(){
      await this.getRoomInfo();
  }
}
